<template>
  <div>
    <b-modal
      id="modal-delete"
      size="md"
      centered
      title="Perhatian .... !!!"
      header-bg-variant="danger"
      header-text-variant="light"
      @keydown.enter.prevent="hapus()"
    >
      <p>Apakah anda yakin akan menghapus data ini ?</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-delete')">
          Tidak
        </b-button>
        <b-button
          variant="primary"
          :disabled="busy"
          @click="hapus()"
        >
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: ["data"],
  name: "modalDelete",
  data() {
    return {
      button: "Hapus",
      busy: false,
    };
  },
  methods: {
    hapus() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.data.id = vm.data.masterPenilaianId;
      vm.$axios
        .post("masterPenilaian/delete", vm.data)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "success",
              msg: "BERHASIL MENGHAPUS MASTER PENILAIAN",
              showing: true,
            });
            this.$bvModal.hide("modal-delete");
          } else {
            vm.button = "Hapus";
            vm.busy = false;
            vm.$emit("alert", {
              variant: "danger",
              msg: _.toUpper(res.data.message),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Hapus";
          vm.busy = false;
          vm.$emit("alert", {
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
        });
    },
  },
};
</script>
